/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvaluationSource } from './EvaluationSource';
import {
    EvaluationSourceFromJSON,
    EvaluationSourceFromJSONTyped,
    EvaluationSourceToJSON,
} from './EvaluationSource';

/**
 * 
 * @export
 * @interface EvaluationChartRequest
 */
export interface EvaluationChartRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof EvaluationChartRequest
     */
    groupMetricNames?: Array<string>;
    /**
     * 
     * @type {EvaluationSource}
     * @memberof EvaluationChartRequest
     */
    source?: EvaluationSource;
    /**
     * Ordered selection of at least 1 source, possibly from several projects; mutually exclusive with source
     * @type {Array<EvaluationSource>}
     * @memberof EvaluationChartRequest
     */
    sources?: Array<EvaluationSource>;
    /**
     * 
     * @type {string}
     * @memberof EvaluationChartRequest
     */
    xMetricName: string;
    /**
     * 
     * @type {string}
     * @memberof EvaluationChartRequest
     */
    yMetricName: string;
}

/**
 * Check if a given object implements the EvaluationChartRequest interface.
 */
export function instanceOfEvaluationChartRequest(value: object): value is EvaluationChartRequest {
    if (!('xMetricName' in value) || value['xMetricName'] === undefined) return false;
    if (!('yMetricName' in value) || value['yMetricName'] === undefined) return false;
    return true;
}

export function EvaluationChartRequestFromJSON(json: any): EvaluationChartRequest {
    return EvaluationChartRequestFromJSONTyped(json, false);
}

export function EvaluationChartRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationChartRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'groupMetricNames': json['groupMetricNames'] == null ? undefined : json['groupMetricNames'],
        'source': json['source'] == null ? undefined : EvaluationSourceFromJSON(json['source']),
        'sources': json['sources'] == null ? undefined : ((json['sources'] as Array<any>).map(EvaluationSourceFromJSON)),
        'xMetricName': json['xMetricName'],
        'yMetricName': json['yMetricName'],
    };
}

export function EvaluationChartRequestToJSON(value?: EvaluationChartRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'groupMetricNames': value['groupMetricNames'],
        'source': EvaluationSourceToJSON(value['source']),
        'sources': value['sources'] == null ? undefined : ((value['sources'] as Array<any>).map(EvaluationSourceToJSON)),
        'xMetricName': value['xMetricName'],
        'yMetricName': value['yMetricName'],
    };
}

